<div class="sheet" [class.sendero]="feature?.properties?.categoria === 'sendero'"
    [style.background-image]="'url(assets/images/wonders/' + (feature?.properties?.OBJECTID || 1) + '-1.jpg)'">

    <section class="sheet-logos">
        <img src="../../../assets/images/logo_flor.png" alt="">
    </section>

    <section class="sheet-title">
        <h1 class="sheet-title-text">{{feature?.properties?.denominacion}}</h1>
        <div class="sheet-title-separator"></div>
        <p class="sheet-title-slogan">{{'HOME.AND_MORE' | translate}} {{slogan | translate | lowercase}}</p>
        @if(feature?.properties?.categoria !== 'sendero'){
        <p class="sheet-title-resume">{{feature?.properties?.resumen_informativo}}</p>

        }
    </section>

    @if(feature?.properties?.categoria !== 'sendero'){
    <section class="sheet-info">

        @for (item of parseText(descripcion); track $index) {

        @if ($index % 2 === 0) {
        <div class="sheet-info-item">
            @for (text of divideText(item); track $index) {
            <p class="sheet-info-item-description">{{text}}</p>
            }
        </div>
        <img class="sheet-info-item-img"
            src="../../../assets/images/wonders/{{feature?.properties?.OBJECTID || 1}}-{{$index + 1}}.jpg" alt="">
        } @else {
        <div class="sheet-info-item odd">
            @for (text of divideText(item); track $index) {
            <p class="sheet-info-item-description">{{text}}</p>
            }
        </div>
        <img class="sheet-info-item-img odd-img"
            src="../../../assets/images/wonders/{{feature?.properties?.OBJECTID || 1}}-{{$index + 1}}.jpg" alt="">
        }
        }

    </section>

    }
    @else {
    <section class="sheet-info-sendero">
        <p class="sheet-info-sendero-description"> {{feature?.properties?.descripcion_particular}}</p>
        <img class="sheet-info-item-img odd-img" src=" ../../../assets/images/wonders/{{feature?.properties?.OBJECTID
            || 1}}-{{1}}.jpg" alt="">
        <button style="display: none;">Ver en la Web APP</button>
    </section>
    }







    <!--
    <section class="sheet-description">
        <h2>Texto amplio</h2>
        <div class="sheet-description-text">
            @for (item of description; track $index) {
            <div class="sheet-description-text-item" style="height: unset;">
                <p>{{item}}</p>
            </div>
            }
        </div>
    </section>
    -->

    <!-- Comentado: relatedCategoryPoints ya no está disponible
    <section class="relatedCategories">
        <app-categories-grid [relatedPoints]="relatedCategoryPoints"></app-categories-grid>
    </section>
    -->

</div>